import Vue from 'vue';
import { format, parseISO } from 'date-fns';
import moment from 'moment';
import type { DomicilioReniecyt, PersonaFisica } from '@conacyt/persona-moral-reniecyt-client';
import type { Perfil } from '@conacyt/perfil-usuario-client';

export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm';

export const DATE_TIME_LONG_FORMAT = "yyyy-MM-dd'T'HH:mm";
export const INSTANT_FORMAT = "yyyy-MM-dd'T'HH:mm:ssZ";
export const ZONED_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXXXX";

export function initFilters() {
  Vue.filter('formatDate', value => {
    if (value) {
      return format(parseISO(value), DATE_TIME_FORMAT);
    }
    return '';
  });
  Vue.filter('formatDateMx', value => {
    if (value) {
      return moment(String(value)).format('DD/MM/YYYY');
    }
    return '';
  });
  Vue.filter('formatMillis', value => {
    if (value) {
      return format(new Date(value), DATE_TIME_FORMAT);
    }
    return '';
  });
  Vue.filter('fullNameRepresentante', (p: PersonaFisica) => {
    return `${p.nombre} ${p.apellidoPaterno || ''} ${p.apellidoMaterno || ''}`;
  });
  Vue.filter('fullName', (p: Perfil) => {
    return `${p.principal?.nombre} ${p.principal?.primerApellido || ''} ${p.principal?.segundoApellido || ''}`; // ToDo: recuperar el grado
  });
  Vue.filter('domicilioInstitucion', (domicilio: DomicilioReniecyt) => {
    const parts = [
      `${domicilio.calle} ${domicilio.numero || 'SN'}`,
      domicilio.colonia ? domicilio.colonia : null,
      domicilio.cp ? `C.P. ${domicilio.cp}` : null,
      domicilio.localidad ? domicilio.localidad : null,
      domicilio.municipio,
      domicilio.estado,
      domicilio.pais,
    ].filter(part => part != null && part !== '');

    return parts.join(', ');
  });
}
